import {SnapshotIn, types as t} from 'mobx-state-tree';
import {nanoid} from 'nanoid';
import {MonologScript} from './monolog-script.store';
import {Character} from './character.store';
import {ScriptCaptionWithCharacter} from './script-caption-with-character.store';

export const defaultCharacters = [
  {
    id: nanoid(),
  },
];

export const ConversationScript = MonologScript.named('ConversationScript').props({
  subtitle: t.optional(t.array(ScriptCaptionWithCharacter), []),
  characters: t.optional(t.array(Character), defaultCharacters),
});

export interface ConversationScriptSnapshotIn extends SnapshotIn<typeof ConversationScript> {}
